var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1189_7253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0.765712H2.25C1.80756 0.761209 1.3814 0.932407 1.06504 1.24174C0.74867 1.55108 0.56794 1.97328 0.5625 2.41571V21.9945C0.568923 22.4362 0.750087 22.8575 1.06634 23.166C1.3826 23.4745 1.8082 23.6452 2.25 23.6407H21.75C22.1925 23.6442 22.6183 23.4724 22.9345 23.1629C23.2507 22.8534 23.4316 22.4313 23.4375 21.9888V2.41009C23.4296 1.96895 23.2479 1.54876 22.9319 1.24085C22.6159 0.932933 22.1912 0.762183 21.75 0.765712Z",
    fill: "#0076B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.94578 9.33887H7.34141V20.2645H3.94578V9.33887ZM5.64453 3.90137C6.03399 3.90137 6.4147 4.01688 6.7385 4.23329C7.0623 4.4497 7.31464 4.75729 7.4636 5.11714C7.61255 5.47699 7.65143 5.87294 7.57531 6.25489C7.4992 6.63684 7.3115 6.98764 7.03598 7.2629C6.76046 7.53816 6.40949 7.72551 6.02746 7.80127C5.64544 7.87702 5.24953 7.83776 4.88982 7.68847C4.53011 7.53917 4.22277 7.28654 4.00666 6.96253C3.79056 6.63853 3.67541 6.2577 3.67578 5.86824C3.67628 5.34642 3.88392 4.84614 4.25308 4.47734C4.62224 4.10853 5.12271 3.90137 5.64453 3.90137ZM9.4714 9.33887H12.7264V10.8389H12.7714C13.2252 9.98012 14.3314 9.07449 15.9833 9.07449C19.422 9.06699 20.0595 11.3301 20.0595 14.2645V20.2645H16.6639V14.9489C16.6639 13.6832 16.6414 12.0539 14.8995 12.0539C13.1577 12.0539 12.8614 13.4339 12.8614 14.8664V20.2645H9.4714V9.33887Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1189_7253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.203125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.3cc65a5e4b34ea6120d4eecb03ac13fb.svg";
export { ForwardRef as ReactComponent };